import { useAppUiStore, } from '@/assets/js/src/pinia/appUi'
import { getActivePinia, storeToRefs, } from 'pinia'
import { useOverlayRouteAction, } from '@/assets/js/src/util/composables/useOverlayRouteAction'

export function useClaim () {
    let appUiStore = useAppUiStore(getActivePinia())
    let { claim, } = storeToRefs(appUiStore)
    let { overlayRouteAction, } = useOverlayRouteAction()

    const cancel = function () {
        claim.value = false
        overlayRouteAction()
    }

    return {
        cancel,
    }
}
